import moment from 'moment';

export const getReadableDateTime = (dateInput, format = 'dateTime', utc = true, timezone = null) => {
    // Use moment to parse the input date string as UTC time
    let inputDate = null;
    if (utc) {
        inputDate = moment.utc(dateInput);
    } else {
        inputDate = moment(dateInput);
    }

    // Convert the date to the specified timezone if provided
    if (timezone) {
        inputDate = inputDate.tz(timezone);
    } else {
        inputDate = inputDate.local();
    }

    // Use moment to format the date as local time in the desired format
    switch (format) {
        case 'time':
            return inputDate.format('h:mm A');
        case 'timeCompact':
            return inputDate.format('h:mma');
        case 'date':
            return inputDate.format('ddd, MMM D');
        case 'dateTime':
            return inputDate.format('ddd, MMM D h:mm A');
        case 'dateShort':
            return inputDate.format('MMM D');
        case 'fullDate':
            return inputDate.format('MMM D, YYYY');
        case 'appreviatedDate':
            return inputDate.format('YYYY-MM-DD');
        case 'numberedDate':
            return inputDate.format('YYYYMMDD');
        case 'dayMonthYear':
            return inputDate.format('MM/DD/YYYY');
        case 'day':
            return inputDate.format('dddd');
        case 'dayTime':
            return inputDate.format('ddd h:mma');
        default:
            return inputDate.format('MMMM Do h:mm A');
    }
};

export default getReadableDateTime;
